module.exports = __webpack_public_path__ + "img/avatarMusic.8500fa8d.png";